<button [type]="type" [ngStyle]="{'color' : color}" [disabled]="disabled || loading" [class]="class">
  {{ label }}
  <ion-spinner name="circular" *ngIf="loading"></ion-spinner>
</button>
